"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelBaseInstance = exports.ModelBaseSchema = exports.ModelTypeSchema = void 0;
const zod_1 = require("zod");
const DesignFileNetInfo_1 = require("./DesignFileNetInfo");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
exports.ModelTypeSchema = zod_1.default.enum(['schematic', 'pcb']);
const ModelBaseSchema = (drawingTypeSchema) => zod_1.default.object({
    modelType: exports.ModelTypeSchema,
    designId: zod_1.default.string(),
    designName: zod_1.default.string().optional(),
    sourceFile: zod_1.default.string(),
    drawings: zod_1.default.record(zod_1.default.coerce.number(), drawingTypeSchema.array()),
    edges_bbox: zod_1.default.object({
        minx: zod_1.default.number(),
        miny: zod_1.default.number(),
        maxx: zod_1.default.number(),
        maxy: zod_1.default.number(),
    }),
    initial_zoombox: zod_1.default.object({
        minx: zod_1.default.number(),
        miny: zod_1.default.number(),
        maxx: zod_1.default.number(),
        maxy: zod_1.default.number(),
    }),
    grid: zod_1.default
        .object({
        distance: zod_1.default.number(),
        units: zod_1.default.enum(['mm', 'microns', 'inch', 'mil']),
        multiple: zod_1.default.number().optional(),
        invertX: zod_1.default.boolean().optional(),
        invertY: zod_1.default.boolean().optional(),
    })
        .optional(),
    layerSet: zod_1.default.string(),
    metadata: zod_1.default.record(zod_1.default.string(), zod_1.default.string()).optional(),
    warnings: zod_1.default.string().array(),
    nets: zod_1.default.record(zod_1.default.string(), DesignFileNetInfo_1.DesignFileNetInfoSchema),
    font: zod_1.default
        .object({
        default: zod_1.default.string(),
    })
        .optional(),
});
exports.ModelBaseSchema = ModelBaseSchema;
class ModelBaseInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.nets = new Map();
        this.drawings = new Map();
        this.edges_bbox = {
            minx: Number.POSITIVE_INFINITY,
            miny: Number.POSITIVE_INFINITY,
            maxx: Number.NEGATIVE_INFINITY,
            maxy: Number.NEGATIVE_INFINITY,
        };
        this.initial_zoombox = {
            minx: Number.POSITIVE_INFINITY,
            miny: Number.POSITIVE_INFINITY,
            maxx: Number.NEGATIVE_INFINITY,
            maxy: Number.NEGATIVE_INFINITY,
        };
        this.warnings = [];
        this.modelType = opts.modelType;
        this.designId = opts.designId;
        this.designName = opts.designName;
        this.sourceFile = opts.sourceFile;
        this.drawings = new Map(Object.entries(opts.drawings ?? {}).map(([layer, drawings]) => [Number(layer), new Set(drawings)]));
        this.edges_bbox = opts.edges_bbox ?? this.edges_bbox;
        this.initial_zoombox = opts.initial_zoombox ?? this.initial_zoombox;
        this.grid = opts.grid;
        this.layerSet = opts.layerSet;
        this.metadata = opts.metadata;
        this.warnings = opts.warnings ?? [];
        this.font = opts.font;
        this.nets = new Map(Object.entries(opts.nets ?? {}).map(([name, net]) => [this.netRefCtx.existingOrNewRef(name), new DesignFileNetInfo_1.DesignFileNetInfoInstance(this.context, net)]));
    }
    serializeModelBaseInstanceProps() {
        return {
            modelType: this.modelType,
            designId: this.designId,
            designName: this.designName,
            sourceFile: this.sourceFile,
            edges_bbox: structuredClone(this.edges_bbox),
            initial_zoombox: structuredClone(this.initial_zoombox),
            grid: structuredClone(this.grid),
            layerSet: structuredClone(this.layerSet),
            metadata: structuredClone(this.metadata),
            warnings: structuredClone(this.warnings),
            font: structuredClone(this.font),
            drawings: Object.fromEntries(Array.from(this.drawings.entries()).map(([layer, drawings]) => [layer, Array.from(drawings)])),
            nets: Object.fromEntries(Array.from(this.nets.entries()).map(([name, net]) => [name, net.toJSON()])),
        };
    }
    addNet(net) {
        const netInstance = net instanceof DesignFileNetInfo_1.DesignFileNetInfoInstance ? net : new DesignFileNetInfo_1.DesignFileNetInfoInstance(this.context, net);
        const netName = this.netRefCtx.existingOrNewRef(netInstance.name);
        if (this.nets.has(netName)) {
            this.nets.get(netName).merge(netInstance);
        }
        else {
            this.nets.set(netInstance.name, netInstance);
        }
    }
    getNet(name) {
        return this.nets.get(this.netRefCtx.existingOrNewRef(name));
    }
    renameNet(oldName, newName) {
        this.netRefCtx.existingOrNewRef(oldName).setName(newName);
    }
    addDrawing(layer, drawing) {
        if (!this.drawings.has(layer)) {
            this.drawings.set(layer, new Set());
        }
        this.drawings.get(layer).add(drawing);
    }
    getDrawingLayers() {
        return Array.from(this.drawings.keys());
    }
    getDrawingsOnLayer(layer) {
        return Array.from(this.drawings.get(layer) ?? new Set());
    }
}
exports.ModelBaseInstance = ModelBaseInstance;
//# sourceMappingURL=ModelBase.js.map